import {
  getToken,
  getAgentUserId,
} from '@/utils/auth';
import {Message} from 'element-ui';
import {Notification} from 'element-ui';

const websocket = {
  namespaced: true,
  state: {
    ws: null, //建立的连接
    lockReconnect: false, //是否真正建立连接
    timeout: 15000, //15秒一次心跳
    timeoutObj: null, //客户端心跳倒计时
    serverTimeoutObj: null, //服务端心跳倒计时
    timeoutNum: null, //断开 重连倒计时
    msg: null, //接收到的信息
  },

  mutations: {
    //初始化ws 用户登录后调用
    webSocketInit(state) {
      let that = this;
      //this 创建一个state.ws对象【发送、接收、关闭socket都由这个对象操作】
      state.ws = new WebSocket(`${process.env.VUE_APP_WEBSOCKET_URL}${getToken()}/${getAgentUserId()}?random=${Math.random()}`);
      state.ws.onopen = function(res) {
        console.log('Connection success...');
        /**
         * 启动心跳检测
         */
        that.commit('websocket/start');
      };
      state.ws.onmessage = function(res) {
        if (res.data === 'heartCheck') {
          // 收到服务器信息，心跳重置
          that.commit('websocket/reset');
          console.log(res);
        } else {
          if (res.data === '生产完成') {
            Notification({
              title: '提示',
              type: 'success',
              duration: 0,
              message: '下载报告已生成完毕，请点击下载',
              onClick: function() {
                window.showDownloadList();
                this.close();
              },
            });
          } else {
            let data = JSON.parse(res.data);
            if (data.scene === 'GLOBAL_TOAST') {
              Message({
                message: data.message,
                type: data.type || 'warning',
                duration: 10 * 1000,
              });
            }
            state.msg = res;
          }
        }
      };
      state.ws.onclose = function(res) {
        console.log('Connection closed...');
        console.log(res);
        //重连
        that.commit('websocket/reconnect');
      };
      state.ws.onerror = function(res) {
        console.log('Connection error...');
        //重连
        that.commit('websocket/reconnect');
      };
    },
    reconnect(state) {
      //重新连接
      let that = this;

      let token = getToken();
      if (!token) {
        return;
      }
      if (state.lockReconnect) {
        return;
      }
      state.lockReconnect = true;
      //没连接上会一直重连,30秒重试请求重连，设置延迟避免请求过多
      state.timeoutNum &&
      clearTimeout(state.timeoutNum);
      state.timeoutNum = setTimeout(() => {
        //新连接
        that.commit('websocket/webSocketInit');
        state.lockReconnect = false;
      }, 5000);
    },
    reset(state) {
      //重置心跳
      let that = this;
      //清除时间
      clearTimeout(state.timeoutObj);
      clearTimeout(state.serverTimeoutObj);
      //重启心跳
      that.commit('websocket/start');
    },
    start(state) {
      //开启心跳
      let self = this;
      state.timeoutObj &&
      clearTimeout(state.timeoutObj);
      state.serverTimeoutObj &&
      clearTimeout(state.serverTimeoutObj);
      state.timeoutObj = setTimeout(() => {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (state.ws.readyState === 1) {
          //如果连接正常
          state.ws.send('heartCheck');
        } else {
          //否则重连
          self.commit('websocket/reconnect');
        }
        state.serverTimeoutObj = setTimeout(function() {
          //服务端超时关闭
          state.ws.close();
        }, state.timeout);
      }, state.timeout);
    },
    disconnect(state) {
      //清除时间
      clearTimeout(state.timeoutObj);
      clearTimeout(state.serverTimeoutObj);
      if (state.ws != null) {
        if (state.ws.readyState !== 3) {
          state.ws.close(3001, '主动关闭');
        }
      }
    },
    send(state, data) {
      if (state.ws != null) {
        state.ws.send(JSON.stringify(data));
      }
    },
  },
  actions: {
    disconnect({commit}) {
      commit('disconnect');
    },
  },
  getters: {
    // 获取接收的信息
    socketMsgs: state => {
      return state.msg;
    },
    // 获取ws对象
    ws: state => {
      return state.ws;
    },
  },
};

export default websocket;
